// action types
export const AUTH = "[Auth]";
export const USER_SIGNOUT = "USER_SIGNOUT";
export const USER_SIGNIN = "USER_SIGNIN";
export const USER_SIGNOUT_SUCCESS = "USER_SIGNOUT_SUCCESS";
export const USER_FORGOT_PASSWORD = "USER_FORGOT_PASSWORD";

export const AUTH_ACTIONS = {
  REMOVE_ERROR: "REMOVE_ERROR",
  AUTHENTICATE: "AUTHENTICATE",
  SET_ERROR: "SET_ERROR"
};

export const setError = payload => ({
  type: `${AUTH_ACTIONS.SET_ERROR}`,
  payload
});

export const removeError = () => ({
  type: `${AUTH_ACTIONS.REMOVE_ERROR}`
});

export const authenticateUser = () => ({
  type: `${AUTH_ACTIONS.AUTHENTICATE}`
});

export const userSignIn = payload => ({
  type: `${USER_SIGNIN}`,
  payload
});

export const userSignOut = () => ({
  type: `${USER_SIGNOUT}`
});

export const userForgotPassword = payload => ({
  type: `${USER_FORGOT_PASSWORD}`,
  payload
});



// WEBPACK FOOTER //
// ./src/redux/actions/authActions.js